module.exports = __webpack_public_path__ + "img/Setting.8f1080ae.svg";